export const ratingSubscribers = new Set();

export const openTournamentRating = (playerId) => {
    ratingSubscribers.forEach(cb => cb(playerId || null));
};
